import * as React from 'react';
import * as moment from 'moment-timezone';
import '../../../locale/i18next';
import { useTranslation } from 'react-i18next';
import CalendarControllers from '../CalendarControllers/CalendarControllers';
import Backdrop from '../UI/Backdrop/Backdrop';
import ScreenReaderOnly from '../ScreenReaderOnly/ScreenReaderOnly';
import ControllersEnum from '../../../enums/ControllersEnum';
import { st, classes } from './Manu.st.css';
import ManuCloseIcon from '../../../assets/closeIcon/ManuCloseIcon';
import { Button, Divider } from 'wix-ui-tpa';
var Manu = function (_a) {
    var _b = _a.isTimeZoneShown, isTimeZoneShown = _b === void 0 ? true : _b, onTimezoneChange = _a.onTimezoneChange, onTodayClicked = _a.onTodayClicked, timezone = _a.timezone, _c = _a.className, className = _c === void 0 ? '' : _c, closeManu = _a.closeManu, _d = _a.locale, locale = _d === void 0 ? '' : _d, _e = _a.isEnterClicked, isEnterClicked = _e === void 0 ? false : _e;
    var _f = useTranslation(), t = _f.t, i18n = _f.i18n;
    React.useEffect(function () {
        locale && void i18n.changeLanguage(locale);
    }, [locale]);
    moment.locale(locale);
    moment.tz.setDefault(timezone);
    var todayRefhandler = function (todayRef) {
        isEnterClicked && todayRef && todayRef.focus();
    };
    //@ts-ignore
    var firstButton = React.useRef();
    //@ts-ignore
    var lastButton = React.useRef();
    var onFirstReached = function (e) {
        if (e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            lastButton.current.focus();
        }
    };
    var onLastReached = function (e) {
        if (!e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            firstButton.current.focus();
        }
    };
    var layout = [ControllersEnum.TodayButton, ControllersEnum.Children];
    isTimeZoneShown && layout.splice(1, 0, ControllersEnum.TimezonePicker);
    return (React.createElement("div", { className: st(classes.root, {}, className) },
        React.createElement(Backdrop, { onClick: closeManu }),
        React.createElement(ScreenReaderOnly, null,
            React.createElement("button", { ref: firstButton, onKeyDown: onFirstReached })),
        React.createElement(CalendarControllers
        //@ts-ignore
        , { 
            //@ts-ignore
            locale: locale, onTimezoneChange: onTimezoneChange, todayClicked: onTodayClicked, timezone: timezone, className: classes.ManuControllers, isTimezoneShown: true, layout: layout, 
            //@ts-ignore
            todayRef: todayRefhandler, isMobilePopup: true },
            React.createElement(Divider, { className: classes.Divider }),
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    height: '40px',
                    paddingLeft: '24px',
                    paddingBottom: '12px',
                } },
                React.createElement(ManuCloseIcon, null),
                React.createElement(Button, { onClick: closeManu, className: classes.Close }, t('Google_Calendar_Close')))),
        React.createElement(ScreenReaderOnly, null,
            React.createElement("button", { ref: lastButton, onKeyDown: onLastReached }))));
};
export default Manu;
//# sourceMappingURL=Manu.js.map